/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ prd: NonNullable<unknown>, chat: NonNullable<unknown>, parallel: NonNullable<unknown> }} Mk_Price_LimitsInputs */

const en_mk_price_limits = /** @type {(inputs: Mk_Price_LimitsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.prd} plans · ${i?.chat} agent messages per month · ${i?.parallel} agents at once`)
};

const id_mk_price_limits = /** @type {(inputs: Mk_Price_LimitsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.prd} rencana · ${i?.chat} pesan agent per bulan · ${i?.parallel} agent bersamaan`)
};

/**
* | output |
* | --- |
* | "{prd} plans · {chat} agent messages per month · {parallel} agents at once" |
*
* @param {Mk_Price_LimitsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_limits = /** @type {((inputs: Mk_Price_LimitsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_LimitsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_limits(inputs)
	return en_mk_price_limits(inputs)
});